import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Label, Logo01Png, Logo03Png } from '@employer-on-record/ui';
import { authApi } from '@/services/api';
import { useAuthStore } from '@/stores/auth';

export default function LoginPage() {
	const navigate = useNavigate();
	const { login } = useAuthStore();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [busy, setBusy] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setBusy(true); setError('');
		try {
			const res = await authApi.login(email, password);
			if (res.data.user.role !== 'super_admin') {
				setError('This dashboard is only for Canis Major staff.');
				setBusy(false);
				return;
			}
			login(res.data.user, res.data.token);
			navigate('/');
		} catch (err) {
			setError((err as Error).message || 'Login failed');
		} finally {
			setBusy(false);
		}
	};

	return (
		<div className="min-h-screen flex items-center justify-center bg-background p-6">
			<form onSubmit={handleSubmit} className="w-full max-w-sm bg-card border rounded-xl p-7">
				<div className="flex items-center gap-2 mb-6">
					<img src={Logo03Png} alt="Canis Major" className="h-7 w-7 shrink-0" />
					<img src={Logo01Png} alt="Canis Major" className="h-6" />
					<span className="text-muted-foreground text-[13px]">· Admin</span>
				</div>
				<h1 className="text-xl font-bold mb-1">Welcome back</h1>
				<p className="text-sm text-muted-foreground mb-5">Sign in to manage Canis Major clients.</p>

				<div className="grid gap-3.5">
					<div className="grid gap-1.5">
						<Label htmlFor="email">Email</Label>
						<Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
					</div>
					<div className="grid gap-1.5">
						<Label htmlFor="password">Password</Label>
						<Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
					</div>
					{error && <div className="text-xs text-destructive">{error}</div>}
					<Button type="submit" disabled={busy} className="w-full justify-center mt-2">
						{busy ? 'Signing in…' : 'Sign in'}
					</Button>
				</div>

				<p className="text-[11px] text-muted-subtle mt-5 text-center">
					Run <code className="bg-background px-1 py-px rounded">npm run db:seed</code> to provision an initial super admin.
				</p>
			</form>
		</div>
	);
}
